import { Card, CardContent } from '@components/card';
import { CreateStaffUserForm } from '@components/forms/staff/users/create';
import { BaseLayout } from '@layouts/base';
import { useGet } from '@services/staff/users/get';
import { createFileRoute, redirect, useSearch } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function NewStaffUser() {
  const { t } = useTranslation('app');
  const { duplicateFrom } = useSearch({ strict: false });
  const { data: sourceUser } = useGet(duplicateFrom || '');

  return (
    <BaseLayout isChild title={t('pages.newStaffUser.title')}>
      <Card>
        <CardContent className="p-6">
          <CreateStaffUserForm user={sourceUser} />
        </CardContent>
      </Card>
    </BaseLayout>
  );
}

export const Route = createFileRoute('/u/$localId/_staff/staff/users/new')({
  beforeLoad: ({ context }) => {
    if (!context.userHasPermissions(['staff_users_create'])) {
      throw redirect({
        to: `/u/$localId/${context.userType}/forbidden`,
      });
    }
  },
  component: NewStaffUser,
});
